import cn from 'clsx';
import { ReactNode } from 'react';

import s from '@/components/survey/common/ui/styles/Indicator.module.scss';

export const Indicator = ({ active, children }: { active: boolean; children: ReactNode }) => {
  return (
    <span
      className={cn(s.circle, s.text, {
        [`${s.active}`]: active
      })}
    >
      {children}
    </span>
  );
};

export const IndicatorGroup = ({ children }: { children: ReactNode }) => {
  return <div className={s.wrapper}>{children}</div>;
};
